import { lazy, type ComponentType } from "react";

const RELOAD_KEY = "taskratel-chunk-reloaded";

/**
 * React.lazy wrapper that recovers from stale chunk hashes after a new deploy.
 * On a failed dynamic import it reloads the page once to fetch the fresh build.
 */
export function lazyWithRetry<T extends ComponentType<unknown>>(
  factory: () => Promise<{ default: T }>,
) {
  return lazy(async () => {
    try {
      const mod = await factory();
      window.sessionStorage.removeItem(RELOAD_KEY);
      return mod;
    } catch (error) {
      const alreadyReloaded = window.sessionStorage.getItem(RELOAD_KEY) === "true";
      if (!alreadyReloaded) {
        window.sessionStorage.setItem(RELOAD_KEY, "true");
        window.location.reload();
        // Never resolves; page is reloading.
        return new Promise<{ default: T }>(() => {});
      }
      throw error;
    }
  });
}
